export default "__VITE_ASSET__DI4X7b1r__"